import { ProductCardProduct } from './product-card.types';

export function getBrandName(product: ProductCardProduct): string {
  if ('brand' in product && typeof product.brand?.name === 'string') {
    return product.brand.name;
  }

  if (typeof product.brandName === 'string') {
    return product.brandName;
  }

  return '';
}
